module.exports = __webpack_public_path__ + "img/collection-weddingRingsPolar@2x.df2d760.jpg";